export default function AboutUsCtaSection() {
  return (
    <section
      className="w-full py-24 px-6 relative overflow-hidden"
      style={{ backgroundColor: "#012E72" }}
    >
      {/* Faint vertical grid lines */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            "repeating-linear-gradient(90deg, rgba(255,255,255,0.04) 0px, rgba(255,255,255,0.04) 1px, transparent 1px, transparent 80px)",
        }}
      />

      {/* Soft radial glow behind content */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 70% 60% at 50% 50%, rgba(0,45,181,0.35) 0%, transparent 70%)",
        }}
      />

      <div className="max-w-3xl mx-auto relative flex flex-col items-center text-center gap-8">

        {/* Badge */}
        <div className="flex items-center gap-3">
          <div className="w-1 h-4 rounded-full" style={{ backgroundColor: "rgba(255,255,255,0.4)" }} />
          <span
            className="font-cinzel uppercase tracking-widest text-white-pure"
            style={{ fontSize: "11px", letterSpacing: "0.2em", opacity: 0.6 }}
          >
            Get Started
          </span>
          <div className="w-1 h-4 rounded-full" style={{ backgroundColor: "rgba(255,255,255,0.4)" }} />
        </div>

        {/* Heading */}
        <h2
          className="font-cinzel font-bold text-white-pure uppercase"
          style={{
            fontSize: "clamp(26px, 4vw, 46px)",
            letterSpacing: "0.04em",
            lineHeight: "1.15",
          }}
        >
          Ready to Experience<br />the Paladin Difference?
        </h2>

        {/* Thin rule */}
        <div className="flex items-center gap-3">
          <div className="h-px w-12" style={{ backgroundColor: "rgba(255,255,255,0.2)" }} />
          <div className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: "rgba(255,255,255,0.3)" }} />
          <div className="h-px w-12" style={{ backgroundColor: "rgba(255,255,255,0.2)" }} />
        </div>

        {/* Body */}
        <p
          className="font-constantia text-white-pure leading-relaxed max-w-xl"
          style={{ fontSize: "16px", opacity: 0.65 }}
        >
          Let our experienced team formulate a protection strategy uniquely tailored
          for your specific needs. Coverage that fits your life — not the other way around.
        </p>

        {/* CTA buttons */}
        <div className="flex flex-col sm:flex-row items-center gap-4 mt-2">
          <button
            className="font-cinzel uppercase tracking-widest text-blue-dark bg-white-pure px-8 py-3 rounded-lg transition-all duration-200 hover:bg-white-warm"
            style={{ fontSize: "12px", letterSpacing: "0.15em" }}
          >
            Learn More About Our Services
          </button>

          <button
            className="font-cinzel uppercase tracking-widest text-white-pure px-8 py-3 rounded-lg transition-all duration-200"
            style={{
              fontSize: "12px",
              letterSpacing: "0.15em",
              border: "1.5px solid rgba(255,255,255,0.35)",
              backgroundColor: "transparent",
            }}
            onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.08)";
              e.currentTarget.style.borderColor = "rgba(255,255,255,0.6)";
            }}
            onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.borderColor = "rgba(255,255,255,0.35)";
            }}
          >
            Contact Us for a Quote
          </button>
        </div>

        {/* Bottom decorative rule */}
        <div className="flex items-center gap-4 mt-6 w-full max-w-xs">
          <div className="h-px flex-1" style={{ backgroundColor: "rgba(255,255,255,0.12)" }} />
          <div className="w-1 h-1 rounded-full" style={{ backgroundColor: "rgba(255,255,255,0.2)" }} />
          <div className="h-px flex-1" style={{ backgroundColor: "rgba(255,255,255,0.12)" }} />
        </div>
      </div>
    </section>
  );
}